export const ACCESS_DENIED_PATH = '/accessDenied';
export const ROOT_PATH = '/';
export const SCHEDULE_MANAGER_PATH = '/scheduleManager';
export const SELECTED_SCHEDULES_PATH = '/selectedSchedules';
export const PENDING_CANDIDATES_PATH = '/pendingCandidates';
export const CANDIDATE_MANAGER_PATH = '/candidateManager';
